import { Fragment } from 'react'

import { useReveal } from '@/lib/useReveal'

interface Props {
  text: string
  className?: string
}

/**
 * Headline that rises per character on scroll.
 *
 * The real space between word spans matters: flexbox does not render
 * whitespace-only anonymous items, so the visual gap comes from `gap` while the
 * DOM text stays a readable sentence for screen readers, search engines and
 * copy-paste. Without it the heading exposes as "Everyasset,onbrand."
 */
export function SplitTitle({ text, className = '' }: Props) {
  const { ref, inView } = useReveal<HTMLSpanElement>({ threshold: 0.25 })
  const words = text.split(' ')
  let index = 0

  return (
    <span ref={ref} className={`split-title ${className}`.trim()}>
      {words.map((word, wi) => (
        <Fragment key={`${word}-${wi}`}>
          {wi > 0 ? ' ' : null}
          <span className="split-title__word">
            {Array.from(word).map((ch, ci) => (
              <span
                key={`${ch}-${ci}`}
                className="split-title__char"
                data-in={inView}
                style={{ ['--i' as string]: index++ }}
              >
                {ch}
              </span>
            ))}
          </span>
        </Fragment>
      ))}
    </span>
  )
}
